import { darken } from '@mui/material/styles';

const VSUITE = '#56c4c4';

export const vatItBrand = {
  black: { main: '#333333' },
  vfile: { main: '#2963b5' },
  vsuite: {
    main: VSUITE,
    text: darken(VSUITE, 0.2),
    hover: darken(VSUITE, 0.1),
  },
} as const;
